<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>文件上传</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!--      <a-form-model-item label="短剧名称" prop="videoId" >-->
      <!--        &lt;!&ndash;        <a-input v-model="form.videoId" placeholder="请输入短剧id" />&ndash;&gt;-->
      <!--        <a-select-->
      <!--          v-model="form.videoId"-->
      <!--          showSearch-->
      <!--          style="width: 100%"-->
      <!--          placeholder="请選择短剧"-->
      <!--          allow-clear-->
      <!--          optionFilterProp="children"-->
      <!--        >-->
      <!--          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item,index) in listAll">-->
      <!--            {{item.videoName}}-->
      <!--          </a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="当前集数" prop="serialNumber" >-->
      <!--        <a-input-number :min="1" v-model="form.serialNumber" placeholder="请输入当前集数" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="購買類型" prop="type" >-->
      <!--&lt;!&ndash;        <a-input v-model="form.type" placeholder="请输入是否可以使用必捷斯购买 0-否 1-是" />&ndash;&gt;-->

      <!--        <a-select placeholder="请選择購買類型" v-model="form.type">-->
      <!--          <a-select-option :key="0">免费</a-select-option>-->
      <!--          <a-select-option :key="1">必捷斯</a-select-option>-->
      <!--          <a-select-option :key="2">钻石</a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-model-item>-->

      <!--      <a-form-model-item label="短剧时长" prop="duration" >-->
      <!--        <a-input v-model="form.duration" placeholder="请输入短剧时长" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="視頻" prop="videoUrl">
        <!--        <a-input v-model="form.videoUrl" placeholder="请输入短剧url" />-->
        <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.videoUrl"
            action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
            :showUploadList="false"
            :beforeUpload="beforeUploadVideo"
            :customRequest="handleChange"
        >
          <video :src="form.videoUrl" v-if="form.videoUrl" width="300" height="150" controls></video>

          <!--          <img v-if="form.videoUrl" :src="form.videoUrl" alt="logo"-->
          <!--               style="height:104px;max-width:300px"/>-->
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>

            <div class="ant-upload-text">上传</div>
          </div>
          <!--          <a-spin v-if="uploadLoading" />-->
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="中文字幕" prop="subtitleCn">
        <!--           action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"-->
        <a-upload
            action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
            :showUploadList="false"
            :customRequest="handleChangeCn"
        >
          <a-button type="primary" v-if="form.subtitleCn">更换</a-button>
          <a-button v-else>
            <a-icon type="upload"/>
            上传
          </a-button>
        </a-upload>
      </a-form-model-item>
      <!--      action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"-->
<!--      <a-form-model-item label="英文字幕" prop="subtitleEn">-->
<!--        &lt;!&ndash;        {{fileListEn}}&ndash;&gt;-->
<!--        <a-upload-->
<!--            action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"-->
<!--            :showUploadList="false"-->
<!--            :customRequest="handleChangeEn"-->
<!--        >-->
<!--          <a-button type="primary" v-if="form.subtitleEn">更换</a-button>-->
<!--          <a-button v-else>-->
<!--            <a-icon type="upload"/>-->
<!--            上传-->
<!--          </a-button>-->
<!--        </a-upload>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="視頻URL" prop="serialNumber">
        <a-input  v-model="this.videoUrl" placeholder="視頻URL"/>
      </a-form-model-item>

      <a-form-model-item label="中文字幕URL" prop="serialNumber">
        <a-input  v-model="this.china" placeholder="中文字幕URL"/>
      </a-form-model-item>

<!--      <a-form-model-item label="英文字幕URL" prop="serialNumber">-->
<!--        <a-input  v-model="this.engilsh" placeholder="英文字幕URL"/>-->
<!--      </a-form-model-item>-->

      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入內容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">-->
<!--            保存-->
<!--          </a-button>-->
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getGather, addGather, updateGather} from '@/api/shortVideo/video/gather'
import {listVideo} from '@/api/shortVideo/video/video'
import TagSelectOption from "@/components/TagSelect/TagSelectOption";
import UploadFileToVOD from "@/api/shortVideo/vod.js"
import UploadFileToOSS from "@/utils/upload-file-to-oss";

export default {
  name: 'UploadFileeForm',
  props: {},
  components: {
    TagSelectOption
  },
  data() {
    return {
      listAll: [],
      submitLoading: false,
      formTitle: '',
      videoUrl: '',
      china: '',
      engilsh: '',
      progress: 0,
      uploadLoading: false,
      // 表单参数
      form: {
        id: null,

        type: null,

        duration: null,

        videoUrl: null,

        videoId: null,

        serialNumber: null,

        createTime: null,

        remark: null,
        subtitleCn: null,
        subtitleEn: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      fileList: [],
      fileListEn: [],
      rules: {
        type: [
          {required: true, message: '購買類型不能為空'}
        ],
        duration: [
          {required: true, message: '短剧时长不能為空'}
        ],
        videoUrl: [
          {required: true, message: '視頻不能為空'}
        ],
        videoId: [
          {required: true, message: '短剧名称不能為空'}
        ],
        serialNumber: [
          {required: true, message: '当前集数不能為空'}
        ]
      }
    }
  },
  filters: {},
  created() {
    this.getGather();
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    beforeUploadVideo:function (file) {
      debugger
      var fileType = file.type;
      if (fileType.indexOf('video') < 0) {
        this.$message.warning('请上传視頻');
        this.form.videoUrl = '';
        return false
      }

      //TODO 驗證文件大小
    },
    handleChangeCn(info) {
      var fileType = info.file.name;
      if (fileType.indexOf('vtt') < 0) {
        this.$message.warning('请上传vtt文件');
        this.form.subtitleCn=''
      }

      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.subtitleCn = fileName[0];//文件名
          that.china = fileName[0];//文件名
        }
      });
      // if (info.file.status === 'done') {
      //   console.log(info.file.response.data.mediaUrl);
      //   this.form.subtitleCn = info.file.response.data.mediaUrl;
      //   // Get this url from response in real world.
      //   // getBase64(info.file.originFileObj, imageUrl => {
      //   //   this.imageUrl = imageUrl;
      //   //   this.uploadLoading = false;
      //   // });
      // } else {
      //   this.form.subtitleCn = "";
      // }
      return;
      if(info.file.status === 'removed') {
        this.fileList = []
      } else {
        let fileList = [...info.fileList];
        fileList = fileList.slice(-1);
        fileList[0].name = '文件'
        fileList = fileList.map(file => {
          if (file.response) {
            file.url = file.response.url;
          }
          return file;
        });
        this.fileList = fileList;
        console.log(this.fileList);
        if (info.file.status === 'done') {
          console.log(info.file.response.data.mediaUrl);
          this.form.subtitleCn = info.file.response.data.mediaUrl;
          this.china = info.file.response.data.mediaUrl;
          // Get this url from response in real world.
          // getBase64(info.file.originFileObj, imageUrl => {
          //   this.imageUrl = imageUrl;
          //   this.uploadLoading = false;
          // });
        } else {
          this.form.subtitleCn = "";
        }
      }

    },
    handleChangeEn(info) {
      var fileType = info.file.name;
      if (fileType.indexOf('vtt') < 0) {
        this.$message.warning('请上传vtt文件');
        this.form.subtitleEn=''
      }
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.subtitleEn = fileName[0];//文件名
          that.engilsh = fileName[0];//文件名
        }
      });
      // if (info.file.status === 'done') {
      //   console.log(info.file.response.data.mediaUrl);
      //   this.form.subtitleEn = info.file.response.data.mediaUrl;
      //   // Get this url from response in real world.
      //   // getBase64(info.file.originFileObj, imageUrl => {
      //   //   this.imageUrl = imageUrl;
      //   //   this.uploadLoading = false;
      //   // });
      // } else {
      //   this.form.subtitleEn = "";
      // }
      return;
      if(info.file.status === 'removed') {
        this.fileListEn = []
      } else {
        let fileList = [...info.fileList];
        fileList[0].name = '文件'
        fileList = fileList.slice(-1);
        fileList = fileList.map(file => {
          if (file.response) {
            file.url = file.response.url;
          }
          return file;
        });
        this.fileListEn = fileList;
        if (info.file.status === 'done') {
          console.log(info.file.response.data.mediaUrl);
          this.form.subtitleEn = info.file.response.data.mediaUrl;
          this.engilsh = info.file.response.data.mediaUrl;
          // Get this url from response in real world.
          // getBase64(info.file.originFileObj, imageUrl => {
          //   this.imageUrl = imageUrl;
          //   this.uploadLoading = false;
          // });
        } else {
          this.form.subtitleEn = "";
        }
      }


    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }
      let that = this
      that.form.videoUrl = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {

          that.form.videoUrl = fileName[0];//文件名
          that.videoUrl = fileName[0];//文件名
          that.uploadLoading = false;
        }
      });
      that.uploadLoading = false;



    },
    handleUpload(info) { //上传主图(一张图)
      console.log(info)
      let that = this;
      this.form.videoUrl = "";
      this.uploadLoading = true;
      // ossUpload(info.file)
      //  , function (fileName) {
      //   console.log('--------------------------------')
      //   console.log(fileName)
      //   console.log('--------------------------------')
      //   that.uploadLoading = false;
      //   that.form.coverUrl = fileName;
      // }
    },
    getGather() {
      listVideo().then(res => {
        this.listAll = res.data;
      })
    },
    onClose() {
      this.open = false
      this.uploadLoading = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        isGoldBuy: null,
        duration: null,
        videoUrl: null,
        videoId: null,
        serialNumber: null,
        createTime: null,
        remark: null,
        subtitleCn: null,
        subtitleEn: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGather({"id": id}).then(response => {
        this.form = response.data;
        if (response.data.subtitleCn) {
          this.fileList = [{
            uid: '-1',
            name: '文件',
            status: 'done',
            url: response.data.subtitleCn,
          }]
        } else {
          this.fileList = []
        }

        if (response.data.subtitleEn) {
          this.fileListEn = [{
            uid: '1',
            name: '文件',
            status: 'done',
            url: response.data.subtitleEn,
          }]
        } else {
          this.fileListEn = []
        }

        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGather(this.form).then(response => {
              this.$message.success(
                  '修改成功',
                  3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGather(this.form).then(response => {
              this.$message.success(
                  '新增成功',
                  3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
